export { default as callAPI } from './callAPI';
export { getCookie, clearCookie } from './cookie';
export { getParamFromLocation, getParamFromString } from './getParamFromUrl';

export function isDefined<T>(argument: T | undefined | null): argument is T {
  return argument != null && argument !== undefined;
}
